import { CmsStaticPageContent } from '../../../../components/Cms';

export function CmsStaticPageDetailContent() {
  return <CmsStaticPageContent />;
}
